import { render } from "./CategoryBlock.vue?vue&type=template&id=465f59fb&scoped=true"
import script from "./CategoryBlock.vue?vue&type=script&lang=js"
export * from "./CategoryBlock.vue?vue&type=script&lang=js"

import "./CategoryBlock.vue?vue&type=style&index=0&id=465f59fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465f59fb"]])

export default __exports__